module.exports = __webpack_public_path__ + "static/sportovni-den-2022-03-16a3d9278a407931fdcee4430ce33292.jpg";